import { render, staticRenderFns } from "./NoProblem.vue?vue&type=template&id=30cde997&scoped=true"
import script from "./NoProblem.vue?vue&type=script&lang=js"
export * from "./NoProblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cde997",
  null
  
)

export default component.exports